import html from "./MyProviderAccounts.html"
import "./MyProviderAccounts.css"
import moment from 'moment-timezone';
import { linkAccount } from '../../../helpers/providerAccounts';
import { deleteProviderAccount, fetchProviderAccountData } from '../../../api/participant/providerAccounts';

var module = angular.module("ResearchKitApplicationModule");

module.component('myProviderAccounts', {
	template: html,
	bindings: {},
	controller: 'myProviderAccountsController',
	controllerAs: 'vm'
});

module.controller("myProviderAccountsController", ["$http", "$scope", "ceUrl",
	function ($http, $scope, ceUrl) {
		var vm = this;
		vm.loading = true;
		vm.fetchingData = {};
		vm.removingAccount = {};

		$http.get(ceUrl.make("api/cfhrprovideraccounts/provideraccounts/"))
			.then(function (response) {
				vm.myProviderAccounts = response.data;
			})
			.finally(function () {
				vm.loading = false;
			});

		vm.getAccountStatusText = function (account) {

			if (!account.LastLog) return "Waiting for first update...";

			if (account.LastLog.IsError) {
				if (account.LastLog.Unauthorized) {
					return "Access expired. Please reconnect for us to pull your latest records.";
				}

				return "Unexpected error occurred.";
			}

			if (account.LastLog.Time) {
				return moment(account.LastLog.Time).fromNow() + ": " + account.LastLog.Message;
			}

			return account.LastLog.Message;
		};

		vm.getAccountStatusClass = function (account) {
			if (account.LastLog && account.LastLog.IsError) return "error";

			return "";
		};

		vm.reconnectAccount = function (account) {
			linkAccount(account.Provider.ID, null, account.ID);
		};

		vm.fetchData = function (account) {
			vm.fetchingData[account.ID] = true;
			fetchProviderAccountData(account.ID).finally(function () {
				$scope.$applyAsync(function () {
					vm.fetchingData[account.ID] = false;
				});
			});
		};

		vm.removeAccount = function (account) {
			if (!window.confirm("Are you sure you'd like to delete the " + account.Provider.Name + " data from your record?")) {
				return;
			}

			vm.removingAccount[account.ID] = true;
			deleteProviderAccount(account.ID)
				.then(function () {
					$scope.$applyAsync(function () {
						vm.myProviderAccounts = _.reject(vm.myProviderAccounts, function (a) { return a.ID === account.ID; });
					});
				})
				.finally(function () {
					$scope.$applyAsync(function () {
						vm.removingAccount[account.ID] = false;
					});
				});
		};
	}
]);